import { ErrorMessage, useField, useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import Container from '../../containers/container';
import { VStack } from '../../layouts/stack.layout';

import 'react-datepicker/dist/react-datepicker.css';

type Props = {
  name: string;
  label: string;
};

const styles = {
  'form-group__wrapper': 'w-full',
  'form-group__container':
    'form-group w-full border border-dark-gray rounded-md px-2 py-1 relative',
  'form-group__input': 'bg-inherit font-text',
  'form-group__label': 'font-text text-info text-2xs capitalize',
  'form-group__error': 'font-text text-info text-xs text-error',
};

function DatePickerFormGroup(props: Props) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  return (
    <VStack gap="xs" extensions={styles['form-group__wrapper']}>
      <VStack gap="xs" colReverse extensions={styles['form-group__container']}>
        <DatePicker
          className={styles['form-group__input']}
          {...field}
          {...props}
          selected={(field.value && new Date(field.value)) || null}
          onChange={(val) => {
            setFieldValue(field.name, val);
          }}
        />
        <label htmlFor={props.name} className={styles['form-group__label']}>
          {props.label}
        </label>
      </VStack>
      <Container extensions={styles['form-group__error']}>
        <ErrorMessage name={props.name} />
      </Container>
    </VStack>
  );
}

export default DatePickerFormGroup;
